<script>
import { bus } from "@store/dau"
export default {
  props: {
    label:String,
    type:{type:String,default:'text'},
    value:{default:''},
    small:Boolean,
    large:Boolean,
    noborder:Boolean,
    cols:Number,
    placeholder: {type:String,default:''},
    options:Array,
    multiple:Boolean,
    trueval:{},
    falseval:{},
    readonly:Boolean,
    follow:String,
    height:String,
    rows:{type:Number,default:3},
  },
  computed: {
     xvalue() {
       var x=typeof(this.value) ;
       if (this.trueval && this.value==this.trueval) return true;
       if (this.falseval && this.falsevalue==this.trueval) return false;
       if (x=="undefined") return false;
       if (x=="number") return this.value==1?true:false
       if (x=="string" ) return this.value=="1"?true:false
       return this.value;
     } ,
     xplaceholder() {
        return this.readonly?'':(this.placeholder || '');
     }
  },
  render(h) {
     var sc=this;
     function getclass() {
      let aa ="form-control col "; //let aa="col ";
      if (sc.follow) aa+=" noroundright"
      if (sc.small) aa+=" small"
      if (sc.large) aa+=" large"
      if (sc.noborder) aa+=" noborder"
      return aa;
    }
    function getstylearea() {
       if (sc.height) {
          return { height:sc.height};
       } else {
         return {}
       }
    }
    var rr=[];
    var r2=[];
    if (this.label) {
      // mette l'etichetta!
      r2.push(
        h("d-label", {
          attrs: {
            label:this.label
          }
        }
      ));
    }
    if (this.type && this.type.toLowerCase()=="select") {
        let r1=[];
        if (this.options && this.options.length>0) {
          if (typeof(this.options[0])=='string') {
            for (let i=0;i<this.options.length;i++) {
              r1.push(
                h("option",{
                  attrs: {
                      value:this.options[i]
                  }
                },this.options[i]  
              ));
            }
          } else {
            for (let i=0;i<this.options.length;i++) {
              r1.push(
                h("option",{
                  attrs: {
                      value:this.options[i].cod 
                  }
                },this.options[i].des?this.options[i].des:(this.options[i].cod?'* '+(this.options[i].cod || '')+' *':''  )
              ));
            }
          }
        }
        rr.push(h("select",{
          class:getclass(),
          attrs: {
              readonly:this.readonly
          },
          domProps:{
              multiple:this.multiple,
              value:this.value,
          },
          on: {
            input: e => {      
              if (typeof(this.value)=="number") { 
                 var nn=Number(e.target.value);
                  this.$emit("input",nn);  
              } else {
                  this.$emit("input",e.target.value); 
              }
            }
          }
        },r1))
    } else if (this.type && this.type.toLowerCase()=="area") {
        rr.push(h("textarea", {
          class:getclass(),
          style:getstylearea(),
          attrs: {
              readonly:this.readonly
          },
          domProps: {
             placeholder:this.xplaceholder,
             value:this.value 
          },
          on: {
            input: e => {
               this.$emit("input",e.target.value);
            }
          }
        }))
   } else if (this.type && (this.type.toLowerCase()=="check" || this.type.toLowerCase()=="checkbox" || this.type.toLowerCase()=="radio") ) {
        rr.push(h("input", {
          class:getclass(),
          attrs: {
              readonly:this.readonly
          },
          domProps: {
             type:'checkbox',
             checked:this.xvalue
          },
          on: {
            click: e => {
              var q=e.target.checked;
              if (this.type.toLowerCase()=="radio" && !q) {
                 e.preventDefault();
              } else {
              // il checkbox è complicato perchè può assumere diversi tipi di valore
              if (q && this.trueval) {
                 q=this.trueval;
              } else if (!q && this.falseval)  {
                 q=this.falseval;   
              } else {               
                var x=typeof(this.value);
                if (x=="undefined" || x=="number") q=q?1:0;
                if (x=="string" ) q=q?"1":"0";
              }
               this.$emit("input",q);
              }
            }
          }
        })) 
    } else {
        rr.push(h("input", {
          class:getclass(),
          attrs: {
              readonly:this.readonly
          },
          domProps: {
             type:this.type,
             placeholder:this.xplaceholder ,
             value:this.value,
          },
          on: {
            input: e => {
               this.$emit("input",e.target.value);
            }
          }
        }))
    }
    if (this.follow) {
      var aa=""
      if (this.small) aa= "small";
      if (this.large) aa="large";
       rr.push(h("button",{
          class:"btn btn-warning noroundleft follow "+aa,
          on: {
            click: e=> {
               var x=this.follow.trim().split('#').join(this.value);
               if (x) bus.$emit('routeadd',{cod:x});
            }
          }
       },"➤"));
    }
    r2.push(h("div",{
      class:"row"
    },rr))
    var aa=this.cols && Number.isInteger(this.cols) && this.cols>0 && this.cols<13?"col-"+this.cols:"col";
    var r3=h("div",{
       class:"px-2"
    },r2)
    
    return h("div",{
      class:aa
    },[r3])
  },
  renderErr(h,err) {
    return h('pre', { style: { color: 'red' }}, err.stack);
  }
}
</script>
 



// WEBPACK FOOTER //
// src/_eng/globals/dinput.vue